// Typelizer digest 149c66a8ce578c5408a59e731c3f7c69
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /admin/productions/import */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/import', {}, options),
    method: 'post',
  }),

  /** GET /admin/productions/:production_id/archive */
  show: (
    params: { productionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/archive', params, options),
    method: 'get',
  }),
}
